var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BannerPictureThumbnailForm',{attrs:{"is-loading":_vm.isLoading,"banner-type":_vm.bannerType},on:{"onSubmit":_vm.handleSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }